import { render, staticRenderFns } from "./CriaTokenApp.vue?vue&type=template&id=33ecedd4"
import script from "./CriaTokenApp.vue?vue&type=script&lang=js"
export * from "./CriaTokenApp.vue?vue&type=script&lang=js"
import style0 from "./CriaTokenApp.vue?vue&type=style&index=0&id=33ecedd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports